import Icons from "../../../../../components/icons";

const Alert = ({
  icon,
  type = "danger",
  text = "Use this if you've updated your brand or messaging—this will reset your AI agents to ignore any old positioning or previous direction. Changes made here affect how all of your agents think and behave. Proceed with caution. ",
}) => {
  const alertType = {
    danger: "bg-red-100 border-2 !border-red-500 !text-red-900",
    warning: "bg-yellow-100 border-2 !border-yellow-500 !text-yellow-900",
  };
  return (
    <div role="alert" className={`px-5 py-2 rounded-md ${alertType[type]}`}>
      <span className="mr-1">{icon || <Icons id={"warningIcon"} />}</span>
      <span className="text-md">{text}</span>
    </div>
  );
};

export default Alert;
